/**
 * Vehicle road tax category values
 */
export enum VehicleRoadTaxRecordCategoryEnum {
	VEHICLE = 'vehicle',
}
